import { Row, Col, Card, Table, DatePicker } from "antd";

import React, { useState, useEffect } from "react";

import moment from "moment";
import lang from "../../helper/langHelper";
const { RangePicker } = DatePicker;

function LastTransaction({ data, loading }) {
  const [list, setList] = useState(data);
  const [pagination, setPagination] = useState(5);

  useEffect(() => {
    if (!data) return;
    setList(data);
    setPagination(data?.length);
    console.log("data ::", data);
  }, [data]);

  const columns = [
    {
      title: lang("Transaction ID"),
      dataIndex: "transactionId",
      key: "transactionId",
      render: (_, { transactionId }) => {
        return transactionId ? <span className="cap">{transactionId}</span> : "-";
      },
    },
    {
      title: lang("Receipent Name"),
      dataIndex: "receipent",
      key: "receipent",
      render: (_, { receipent }) => {
        return receipent ? <span className="cap">{receipent?.name}</span> : "Admin";
      },
    },
    {
      title: lang("Payee Name"),
      dataIndex: "payee",
      key: "payee",
      render: (_, { payee }) => {
        console.log("payee", payee);
        return payee ? (
          <span className="cap">{payee?.name}</span>
        ) : (
          "Admin"
        );
      },
    },
    {
      title: lang("Transaction Type"),
      dataIndex: "type",
      key: "type",
      render: (_, { type }) => {
        return type ? <span className="cap">{type}</span> : "-";
      },
    },
    {
      title: lang("Bokking Id"),
      dataIndex: "bookingId",
      key: "bookingId",
      render: (_, { bookingId }) => {
        return bookingId ? <span className="cap">{bookingId?.bookingId}</span> : "-";
      },
    },
    {
      title: lang("Order Id"),
      dataIndex: "orderId",
      key: "orderId",
      render: (_, { orderId }) => {
        return orderId ? <span className="cap">{orderId?.orderId}</span> : "-";
      },
    },
    {
      title: lang("Payment Status"),
      dataIndex: "paymentStatus",
      key: "paymentStatus",
      render: (_, { paymentStatus }) => {
        return paymentStatus ? <span className="cap">{paymentStatus}</span> : "-";
      },
    },
    {
      title: lang("Transaction Date & Time"),
      dataIndex: "created_at",
      key: "created_at",
      render: (_, { created_at }) => {
        return <span className="cap">{moment(created_at).format("lll")}</span>;
      },
    },
  ];

  return (
    <>
      <div className="tabled bannerMain">
        <Row gutter={[24, 0]}>
          <Col xs={24} xl={24}>
            <div className="table-responsive customPagination">
              <Table
                loading={loading}
                columns={columns}
                dataSource={list}
                pagination={{
                  defaultPageSize: 10,
                  responsive: true,
                  total: pagination,
                  // showSizeChanger: true,
                  // pageSizeOptions: ["10", "20", "30", "50"],
                }}
                className="ant-border-space"
              />
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default LastTransaction;
